export default __webpack_public_path__ + "static/media/Gold-Plated-Bangles.e9d30ab5.jpg";